const guiColors = {
    // Primary Frutiger Aero Blue (Glossy, water/glass style)
    'motion-primary': '#0078d7',
    'motion-primary-transparent': 'rgba(0, 120, 215, 0.65)',
    'motion-tertiary': '#005a9e',

    // Windows Aero window translucency and gloss effects
    'looks-secondary': '#4ba3e3',
    'looks-transparent': 'rgba(75, 163, 227, 0.35)',
    'looks-light-transparent': 'rgba(255, 255, 255, 0.4)', // Bright white reflection
    'looks-secondary-dark': 'hsla(205, 75%, 35%, 1)',

    // Secondary eco/aquatic greens and blues (Skeuomorphic nature)
    'extensions-primary': 'hsla(185, 85%, 45%, 1)',
    'extensions-tertiary': 'hsla(185, 85%, 25%, 1)',
    'extensions-transparent': 'hsla(185, 85%, 45%, 0.4)',
    'extensions-light': 'hsla(150, 60%, 90%, 1)', // Light "nature" Frutiger green touch

    // Water bubble / glass highlight effect
    'drop-highlight': '#60cdff',

    // Frutiger Aero gradient: Azure blue, white glossy highlights, and aurora green undertones
    'menu-bar-background-image': 'linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(0, 162, 232, 0.7) 15%, rgba(0, 114, 198, 0.8) 50%, rgba(0, 60, 120, 0.9) 100%)'
};

const blockColors = {
    // Glossy Aqua / Aero style checkbox button
    checkboxActiveBackground: '#00fa9a', // Bright lagoon green for activation
    checkboxActiveBorder: '#00a86b'
};

export {
    guiColors,
    blockColors
};
